import { ImageAtoms } from '@vfit/shared/atoms';
import { useDeviceType } from '@vfit/shared/hooks';
import { ISummary } from '@vfit/shared/models';
import { purify } from '@vfit/shared/themes';
import {
  Container,
  ImageContainer,
  TopImageContainer,
  InnerContainer,
  Title,
  Subtitle,
} from './summary.style';
import { OfferDetails } from './offerDetails';

const Summary: React.FC<ISummary> = ({ data, product, showOfferDetails = false }) => {
  const {
    primaryImage,
    primaryImageMobile,
    secondaryImage,
    secondaryImageMobile,
    mainTitle,
    subtitle,
  } = data;

  const { isMobile } = useDeviceType();
  const [subtitlePurified] = purify([subtitle || '']);

  return (
    <Container>
      <TopImageContainer>
        <ImageAtoms
          nameCard="topImage"
          image={primaryImage}
          imageMobile={primaryImageMobile}
          isMobile={isMobile}
        />
        <ImageContainer>
          <ImageAtoms
            nameCard="secondaryImage"
            image={secondaryImage}
            imageMobile={secondaryImageMobile}
            isMobile={isMobile}
          />
        </ImageContainer>
      </TopImageContainer>
      <InnerContainer>
        <Title>{mainTitle}</Title>
        <Subtitle dangerouslySetInnerHTML={{ __html: subtitlePurified || '' }} />
        {showOfferDetails && (
          <OfferDetails
            category={product?.category?.toUpperCase()}
            price={product?.price}
            originalPrice={product?.originalPrice}
            description={product?.description}
            recurrence={product?.recurrence}
            specs={product?.subprice}
          />
        )}
      </InnerContainer>
    </Container>
  );
};
export default Summary;

